import { Component, Input, OnInit } from '@angular/core';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { CustomEventService } from '@shared/services/custom-event.service';
import { PropertiesService } from "@core/services/properties.service";

@Component({
  selector: 'app-kpi-list-modal',
  templateUrl: './kpi-list-modal.component.html'
})
export class KpiListModalComponent implements OnInit {

  PAGE_SIZE = 15;

  @Input() data;
  @Input() type: string;
  @Input() loading: boolean;
  @Input() kpi;
  @Input() title: string;

  allChecked = false;
  indeterminate = true;

  constructor(private customEventService: CustomEventService,
              public propertiesService: PropertiesService) { }

  ngOnInit() {
    this.kpi = this.kpi.map(item => {
      return {
        label: item.text,
        value: item.id,
        group: item.group,
        checked: this.data.kpis.some(kpi => kpi === item.id)
      }
    });
  }

  updateAllChecked(): void {
    this.indeterminate = false;

    this.kpi = this.kpi.map(item => {
      return {
        ...item,
        checked: this.allChecked ? true : false
      };
    })
  }

  submit(): void {
    this.customEventService.announceEvent(ActionTypesEnum.ADD_KPI_LIST, {
      leagueId: this.data.id,
      kpis: this.kpi.filter(item => item.checked).map(item => item.value)
    });
  }

  cancelModal(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

}
